import { useSelector } from 'react-redux';
import {
  championshipDataSelector,
  championshipIsLoadedSelector,
  championshipIsLoadingSelector,
} from 'modules/championship/store/championship/selectors';

export const useChampionship = (championshipId: number) => {
  const isLoading = useSelector(championshipIsLoadingSelector);
  const isLoaded = useSelector(championshipIsLoadedSelector);
  const data = useSelector(championshipDataSelector(championshipId));

  return {
    isLoading,
    isLoaded,
    data,
  };
};
